module.exports = __webpack_public_path__ + "static/tos-0fea6d36f5ba60f8565a2c3bef613899.pdf";